import * as React from "react";
export const RowMain = props => React.createElement("div", { className: `g-row ${props.className}` }, props.children);
export const Cols2 = props => React.createElement(RowMain, { className: "g-row--2-columns" }, props.children);
export const Cols3 = props => React.createElement(RowMain, { className: "g-row--3-columns" }, props.children);
export const Cols4 = props => React.createElement(RowMain, { className: "g-row--4-columns" }, props.children);
export const Cols5 = props => React.createElement(RowMain, { className: "g-row--5-columns" }, props.children);
export const Cols6 = props => React.createElement(RowMain, { className: "g-row--6-columns" }, props.children);
